export default {
  'user-register.login.userName': 'userName',
  'user-register.login.password': 'password',
  'user-register.login.message-invalid-credentials':
    'Invalid username or password（admin/ant.design）',
  'user-register.login.message-invalid-verification-code': 'Invalid verification code',
  'user-register.login.tab-login-credentials': 'Credentials',
  'user-register.login.tab-login-mobile': 'Mobile number',
  'user-register.login.remember-me': 'Remember me',
  'user-register.login.forgot-password': 'Forgot your password?',
  'user-register.login.sign-in-with': 'Sign in with',
  'user-register.login.signup': 'Sign up',
  'user-register.login.login': 'Login',
  'user-register.register.register': 'Register',
  'user-register.register.get-verification-code': 'Get code',
  'user-register.register.sign-in': 'Already have an account?',
  'user-register.register-result.msg': 'Account：registered at {email}',
  'user-register.register-result.activation-email':
    'The activation email has been sent to your email address and is valid for 24 hours. Please log in to the email in time and click on the link in the email to activate the account.',
  'user-register.register-result.back-home': 'Back to home',
  'user-register.register-result.view-mailbox': 'View mailbox',
  'user-register.email.required': 'Please enter your email!',
  'user-register.email.wrong-format': 'The email address is in the wrong format!',
  'user-register.userName.required': 'Please enter your userName!',
  'user-register.password.required': 'Please enter your password!',
  'user-register.password.twice': 'The passwords entered twice do not match!',
  'user-register.strength.msg':
    "Please enter at least 6 characters and don't use passwords that are easy to guess.",
  'user-register.strength.strong': 'Strength: strong',
  'user-register.strength.medium': 'Strength: medium',
  'user-register.strength.short': 'Strength: too short',
  'user-register.confirm-password.required': 'Please confirm your password!',
  'user-register.phone-number.required': 'Please enter your phone number!',
  'user-register.phone-number.wrong-format': 'Malformed phone number!',
  'user-register.verification-code.required': 'Please enter the verification code!',
  'user-register.title.required': 'Please enter a title',
  'user-register.date.required': 'Please select the start and end date',
  'user-register.goal.required': 'Please enter a description of the goal',
  'user-register.standard.required': 'Please enter a metric',
  'user-register.form.get-captcha': 'Get Captcha',
  'user-register.captcha.second': 'sec',
  'user-register.form.optional': ' (optional) ',
  'user-register.form.submit': 'Submit',
  'user-register.form.save': 'Save',
  'user-register.email.placeholder': 'Email',
  'user-register.password.placeholder': 'Password',
  'user-register.confirm-password.placeholder': 'Confirm password',
  'user-register.phone-number.placeholder': 'Phone number',
  'user-register.verification-code.placeholder': 'Verification code',
  'user-register.title.label': 'Title',
  'user-register.title.placeholder': 'Give the target a name',
  'user-register.date.label': 'Start and end date',
  'user-register.placeholder.start': 'Start date',
  'user-register.placeholder.end': 'End date',
  'user-register.goal.label': 'Goal description',
  'user-register.goal.placeholder': 'Please enter your work goals',
  'user-register.standard.label': 'Metrics',
  'user-register.standard.placeholder': 'Please enter a metric',
  'user-register.client.label': 'Client',
  'user-register.label.tooltip': 'Target service object',
  'user-register.client.placeholder':
    'Please describe your customer service, internal customers directly @ Name / job number',
  'user-register.invites.label': 'Inviting critics',
  'user-register.invites.placeholder':
    'Please direct @ Name / job number, you can invite up to 5 people',
  'user-register.weight.label': 'Weight',
  'user-register.weight.placeholder': 'Please enter weight',
  'user-register.public.label': 'Target disclosure',
  'user-register.label.help': 'Customers and invitees are shared by default',
  'user-register.radio.public': 'Public',
  'user-register.radio.partially-public': 'Partially public',
  'user-register.radio.private': 'Private',
  'user-register.publicUsers.placeholder': 'Open to',
  'user-register.option.A': 'Colleague A',
  'user-register.option.B': 'Colleague B',
  'user-register.option.C': 'Colleague C',
  'user-register.navBar.lang': 'Languages',
};
